import React from "react";
import styled from "styled-components";
import { Colors, Metrics } from "../../theme";

const OutterBar = styled.div`
	display:flex;
	position: relative;
	overflow: hidden;
	height: ${props=>props.radius*2}px;
	background: ${Colors.greyBackgroundColor};
	-moz-border-radius: ${props=>props.radius}px;
	-webkit-border-radius: ${props=>props.radius}px;
	border-radius: ${props=>props.radius}px;
`;
const ValueBar = styled.span`
	background-color:${Colors.antBlueColor};
	width:${props=>props.percent}%;
`;
const ProgressBar = ({
	percent = 50, 
	radius = Metrics.progressBar.bigStorkeWidth / 2
})=>(
	<OutterBar radius={radius}>
		<ValueBar percent={percent} />
	</OutterBar>
);
export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/bar/ProgressBar.js